/** Affichage duplicata — synthèse remboursements & articles retournés (données ticket inchangées). */

export function roundMoney(n) {
  return Math.round(Number(n) * 100) / 100;
}

export function parseSavPaymentReference(reference) {
  if (reference == null || reference === '') return null;
  try {
    const raw = typeof reference === 'string' ? JSON.parse(reference) : reference;
    if (!raw || raw.sav !== true) return null;
    if (raw.ligneQuantites != null && typeof raw.ligneQuantites !== 'object') return null;
    return raw;
  } catch {
    return null;
  }
}

export function lineUnitTtcSafe(line) {
  const total = Number(line?.prixFinal != null ? line.prixFinal : line.prixTotal) || 0;
  const qty = Number(line?.quantite) || 0;
  if (qty <= 0) return roundMoney(total);
  return roundMoney(total / qty);
}

/** Cumule les qty retournées par CommandeProduit.id depuis les paiements négatifs SAV. */
export function aggregateRefundedQtyByLineFromPayments(paiements) {
  const map = {};
  for (const p of paiements || []) {
    if (Number(p.montant) >= -0.001) continue;
    const meta = parseSavPaymentReference(p.reference);
    if (!meta?.ligneQuantites) continue;
    for (const [lineId, qty] of Object.entries(meta.ligneQuantites)) {
      const q = Math.max(0, Math.floor(Number(qty) || 0));
      if (q <= 0) continue;
      map[lineId] = (map[lineId] || 0) + q;
    }
  }
  return map;
}

/**
 * @returns {{ show: boolean, venteInitiale: number, totalRemboursements: number, netApresRemboursements: number }}
 */
export function buildDuplicataRefundSynthesis(ticket, paiements) {
  const pays = paiements || ticket?.paiements || [];
  let totalRemb = 0;
  for (const p of pays) {
    const m = Number(p.montant);
    if (m < -0.001) totalRemb = roundMoney(totalRemb + Math.abs(m));
  }
  const venteInitiale = roundMoney(Number(ticket?.total) || 0);
  if (totalRemb <= 0.001) {
    return { show: false, venteInitiale, totalRemboursements: 0, netApresRemboursements: venteInitiale };
  }
  const net = roundMoney(Math.max(0, venteInitiale - totalRemb));
  return {
    show: true,
    venteInitiale,
    totalRemboursements: totalRemb,
    netApresRemboursements: net,
  };
}

/**
 * Articles retournés — uniquement si metadata SAV valide et qty cohérente.
 * @returns {{ rows: Array, attributionComplete: boolean }}
 */
export function buildDuplicataReturnedArticles(ticket) {
  const produits = ticket?.produits || [];
  const byId = new Map(produits.map((lp) => [lp.id, lp]));
  const refundedByLine = aggregateRefundedQtyByLineFromPayments(ticket?.paiements);
  const rows = [];
  let attributionComplete = Object.keys(refundedByLine).length > 0;

  for (const [lineId, qtyRet] of Object.entries(refundedByLine)) {
    const lp = byId.get(lineId);
    if (!lp) {
      attributionComplete = false;
      continue;
    }
    const sold = Math.max(0, Math.floor(Number(lp.quantite) || 0));
    if (qtyRet > sold) {
      attributionComplete = false;
      continue;
    }
    const unit = lineUnitTtcSafe(lp);
    rows.push({
      lineId,
      nom: lp.produit?.nom || lp.nom || 'Article',
      quantiteVendue: sold,
      quantiteRetournee: qtyRet,
      quantiteConservee: sold - qtyRet,
      montantRetourTtc: roundMoney(unit * qtyRet),
    });
  }

  if (Object.keys(refundedByLine).length > 0 && rows.length === 0) {
    attributionComplete = false;
  }

  return { rows, attributionComplete };
}
